import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getPublicSiteSettings } from '../services/siteContentService';
import QuranVerseOrnament from './QuranVerseOrnament';
import './HeroIntro.css';

const DEFAULT_VERSE = 'وَأَحْسِنُوا ۚ إِنَّ اللَّهَ يُحِبُّ الْمُحْسِنِينَ';

const HeroIntro = () => {
  const { t, i18n } = useTranslation();
  const [intro, setIntro] = useState(() => t('public.home.intro'));
  const [verse, setVerse] = useState(DEFAULT_VERSE);

  useEffect(() => {
    setIntro(t('public.home.intro'));
    getPublicSiteSettings()
      .then((settings) => {
        if (settings?.homepage_intro && !i18n.language?.startsWith('fr')) {
          setIntro(settings.homepage_intro);
        }
        if (settings?.homepage_verse) setVerse(settings.homepage_verse);
      })
      .catch(() => {});
  }, [i18n.language, t]);

  return (
    <div className="hero-intro">
      <div className="hero-intro__inner">
        <div className="hero-intro__verse-block" dir="rtl" lang="ar">
          <QuranVerseOrnament className="hero-intro__ornament" />
          <p className="hero-intro__verse" lang="ar">{verse}</p>
          <QuranVerseOrnament className="hero-intro__ornament" mirrored />
        </div>
        <p className="hero-intro__text">{intro}</p>
      </div>
    </div>
  );
};

export default HeroIntro;
